<template>
  <b-modal :active="active" @update:active="$emit('update:active', $event)" :width="480" scroll="keep">
    <div class="box download-modal">
      <h2 class="title is-5">{{ title }}</h2>
      <p class="subtitle is-6 has-text-grey">
        Selecciona qué quieres exportar a Excel
      </p>
      <div class="download-options">
        <button class="download-option" @click="$emit('download-all')">
          <span class="download-option__icon">
            <b-icon icon="account-group-outline" size="is-medium"></b-icon>
          </span>
          <span class="download-option__text">
            <span class="download-option__title">{{ allLabel }}</span>
            <span class="download-option__desc"
              >{{ allDescription }} ({{ allCount }})</span
            >
          </span>
        </button>
        <button class="download-option" @click="$emit('download-pending')">
          <span class="download-option__icon">
            <b-icon icon="account-clock-outline" size="is-medium"></b-icon>
          </span>
          <span class="download-option__text">
            <span class="download-option__title">{{ pendingLabel }}</span>
            <span class="download-option__desc"
              >{{ pendingDescription }} ({{ pendingCount }})</span
            >
          </span>
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "DownloadOptionsModal",
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Descargar",
    },
    allLabel: {
      type: String,
      default: "Todos",
    },
    allDescription: {
      type: String,
      default: "Exporta la lista completa",
    },
    allCount: {
      type: [Number, String],
      default: 0,
    },
    pendingLabel: {
      type: String,
      default: "Solo los no finalizados",
    },
    pendingDescription: {
      type: String,
      default: "Quienes aún no completan la encuesta",
    },
    pendingCount: {
      type: [Number, String],
      default: 0,
    },
  },
};
</script>

<style scoped>
.download-modal {
  padding: 1.75rem;
}

.download-modal .subtitle {
  margin-bottom: 1.5rem;
}

.download-options {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.download-option {
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
  text-align: left;
  padding: 1rem;
  border: 1px solid #e8e8e8;
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease,
    box-shadow 0.15s ease;
}

.download-option:hover {
  border-color: #7957d5;
  background: #faf8ff;
  box-shadow: 0 2px 8px rgba(121, 87, 213, 0.12);
}

.download-option__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #f1ecfb;
  color: #7957d5;
  flex-shrink: 0;
}

.download-option__text {
  display: flex;
  flex-direction: column;
}

.download-option__title {
  font-weight: 600;
  color: #363636;
}

.download-option__desc {
  font-size: 0.813rem;
  color: #7a7a7a;
}
</style>



// WEBPACK FOOTER //
// src/components/commons/DownloadOptionsModal.vue